













































import { Subscription, EventJson, Event } from 'inscreva-sse-models';
import { SortBy, FilterBy, Priority } from 'ss-commons-front/src/components/SortTable.vue';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { paginationStore } from '@/store/pagination';
import { downloadFile } from '@/utils/download-file';

import { KeysOfType, stringFormatter } from '../models/utils';
import { SubscriptionsExport } from '../services/subscriptionsExport';
import { sessionStore } from '../store/session';
import PaginationComponent from './Pagination.vue';
import SubscriptionListComponent from './SubscriptionList.vue';

@Component({
  components: {
    Pagination: PaginationComponent,
    SubscriptionList: SubscriptionListComponent,
  },
})
export default class SubscriptionDataTableComponent extends Vue {
  @Prop({ required: true })
  private subscriptions!: Array<Subscription>;

  @Prop({ required: true })
  eventExtraFields: { text: string; key: string };

  private search: any = null;

  private file: { filename: string; buffer: any } = null;

  private downloading: boolean = false;

  private sortBy: SortBy<Subscription> = {
    key: 'nome',
    priority: Priority.ASC,
  };

  private filterBy: FilterBy<Subscription> = {
    page: 1,
    limit: paginationStore.limit,
  } as FilterBy<Subscription>;

  get subscriptions_sortered() {
    return this.subscriptions.sort((a, b) => {
      const keyA = (a[this.sortBy.key] || '').toUpperCase();
      const keyB = (b[this.sortBy.key] || '').toUpperCase();
      if (this.sortBy.priority === 'ASC' && keyA > keyB) {
        return 1;
      }
      return -1;
    });
  }

  private async handleExportExcel() {
    this.downloading = true;

    if (!this.file) {
      this.file = await SubscriptionsExport.export(this.subscriptions, this.event);
    }

    downloadFile(this.file.buffer, this.file.filename);
    this.downloading = false;
  }

  get subscriptions_filtered_paginated(): Array<Subscription> {
    return this.subscriptions_filtered.slice(
      ((this.filterBy.page || 1) - 1) * (this.filterBy.limit || 0),
      this.filterBy.limit * (this.filterBy.page || 1),
    );
  }

  get subscriptions_filtered(): Array<Subscription> {
    return !this.search && !this.is_filter_available
      ? this.subscriptions_sortered
      : this.subscriptions_sortered.filter((subscription: Subscription) => {
          const keysToFilter: Array<KeysOfType<Subscription, 'string'>> = ['nome', 'email'];
          return Array.isArray(this.filterBy.value) && this.filterBy.value
            ? Array.isArray(this.filterBy.value) &&
                this.filterBy.value.some((filter) =>
                  stringFormatter(filter, true).includes(stringFormatter(subscription[this.filterBy.key] || '', true)),
                )
            : keysToFilter.some((key) =>
                stringFormatter(subscription[key], true).includes(
                  stringFormatter(this.search, true).slice(0, subscription[key].length),
                ),
              );
        });
  }

  get is_filter_available(): boolean {
    return this.filterBy.value && Array.isArray(this.filterBy.value) && !!this.filterBy.value.length;
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  onVisualize(subscription: Subscription) {
    return this.$router.replace({ path: `subscription/${subscription._id}`, replace: true });
  }

  onActiveStatus(subscription: Subscription) {
    this.$emit('on-activeStatus', subscription);
    return subscription;
  }

  onRemove(subscription: Subscription) {
    this.$emit('on-remove', subscription);
  }

  sortList(sortBy: SortBy<Subscription>) {
    this.sortBy = sortBy;
  }

  filterList(filterBy: FilterBy<Subscription>) {
    this.filterBy = filterBy;
    this.onUpdateData();
  }

  onSearchChange($event: any) {
    this.search = $event.target.value as string;
    this.onUpdateData();
  }

  changeLimit($event: any) {
    const limit: number = $event.target.value;
    this.filterBy.limit = limit;
    paginationStore.changeLimit(limit);
  }

  @Emit()
  onUpdateData() {
    return this.subscriptions_filtered;
  }
}
